module.exports = __webpack_public_path__ + "img/diamond-01.96d25d9f.svg";